<template>
  <div class="sd-temporary-editor round-corner shadow" :style="getStyle()" v-drag v-if="visible && showPanel">
    <div class="sd-head-default between-flex moveable no-select ">
      <div class="head-title">编辑</div>
      <image-button enter-icon="close-white" leave-icon="close-gray" @click="Close"></image-button>
    </div>
    <div class="sd-body-default editor-button-panel left-flex " @mousedown.stop="()=>{}">
      <image-button
        v-for="btn in buttons_"
        :key="btn.name"
        :title="btn.name"
        :leaveIcon="btn.icon + '-gray'"
        :enterIcon="btn.icon + '-blue'"
        width="25px"
        height="25px"
        @click="btn.click(btn.type)"
      ></image-button>
    </div>
  </div>
</template>

<script>
import { Vector as VectorSource } from 'ol/source'
import { Vector as VectorLayer } from 'ol/layer'
import { Draw, Modify, Snap } from 'ol/interaction'
import { Icon, Style, Fill, Stroke } from 'ol/style'
import { FeaturesWriter } from './Utils/FormatTransverter'
import { CoreMap } from './Utils/CoreMap'
/**
 * @description 临时绘制图形
 * @author GuoYun
 */
export default {
  name: 'SdTemporaryEditor',
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    showPanel:{
      type: Boolean,
      default() {
        return false
      },
    },
    continue:{
      type: Boolean,
      default() {
        return true
      },
    },
    geometryStyle: {
      type: Object,
      default() {
        return null
      },
    },
  },
  data() {
    return {
      buttons_: [
        {
          name: '取消',
          icon: 'select',
          type: 'None',
          click: this.addInteraction,
        },
        {
          name: '画点',
          icon: 'point',
          type: 'Point',
          click: this.addInteraction,
        },
        {
          name: '画线',
          icon: 'line',
          type: 'LineString',
          click: this.addInteraction,
        },
        {
          name: '画面',
          icon: 'polygon',
          type: 'Polygon',
          click: this.addInteraction,
        },
        {
          name: '清除',
          icon: 'clear-all',
          type: 'Clear',
          click: this.otherOperate,
        },
        {
          name: '导出',
          icon: 'export',
          type: 'Export',
          click: this.otherOperate,
        },
      ],
      map_: null,
      tempLayer_: null,
      tempSource_: null,
      draw_: null,
      modify_: null,
      snap_: null,
      geomStyle_: null,
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.initControl()
      } else {
        this.removeControl()
        this.$emit('close')
      }
    },
  },
  beforeDestroy() {
    this.map_.removeLayer(this.tempLayer_)
    this.removeInteraction()
  },

  created() {
    this.geomStyle_ =
      this.geometryStyle ||
      new Style({
        stroke: new Stroke({
          color: 'rgb(18,150,219)',
          width: 2,
        }),
        fill: new Fill({
          color: 'rgba(18, 250, 219, 0.1)',
        }),
        image: new Icon({
          src:require('@/assets/images/position.png'),
          anchor: [0.5, 0],
          anchorOrigin: 'bottom-left',
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 1,
        }),
      })
    this.tempSource_ = new VectorSource({ wrapX: false })
    this.tempLayer_ = new VectorLayer({
      source: this.tempSource_,
      style: this.geomStyle_,
      zIndex: CoreMap.TEMPLATE_LAYER_INDEX,
      visible: true,
    })
    this.tempLayer_.set('name', 'templateEditorLayer')
  },
  mounted(){
    if (!this.map_ && this.$parent.map_) {
      this.setMap(this.$parent.map_,this.$parent)
    }
  },
  methods: {
    setMap(map) {
      this.map_ = map
      if (this.visible) {
        this.initControl()
      }
      
    },
    getStyle() {
      const width = 35 * this.buttons_.length + 10
      return { width: width + 'px' }
    },
    removeControl() {
      this.map_.removeLayer(this.tempLayer_)
      this.removeInteraction()
    },
    initControl() {
      this.map_.addLayer(this.tempLayer_)
    },
    addInteraction(type) {
      if (!this.modify_) {
        this.modify_ = new Modify({ source: this.tempSource_ })
        this.snap_ = new Snap({ source: this.tempSource_ })
      }
      this.removeInteraction()

      if (type && type !== 'None') {
        this.draw_ = new Draw({
          source: this.tempSource_,
          type: type,
        })
        this.draw_.on('drawend', (evt) => {
          this.$emit('drawend', evt.feature)
          if (!this.continue) {
            this.removeInteraction()
          }
        })
        this.map_.addInteraction(this.draw_)
        if (this.modify_) {
          this.map_.addInteraction(this.modify_)
        }
        if (this.snap_) {
          this.map_.addInteraction(this.snap_)
        }
      }
    },
    removeInteraction() {
      if (this.draw_) {
        this.map_.removeInteraction(this.draw_)
        this.draw_ = null
      }
      if (this.modify_) {
        this.map_.removeInteraction(this.modify_)
        this.modify_ = null
      }
      if (this.snap_) {
        this.map_.removeInteraction(this.snap_)
        this.snap_ = null
      }
    },
    otherOperate(type) {
      switch (type) {
        case 'Clear':
          this.clearTempLayer()
          break
        case 'Export':
          this.exportGeoJSON()
          break
        case 'Close':
          this.Close()
          break
        default:
          break
      }
    },
    clearTempLayer() {
      this.tempSource_.clear()
      this.removeInteraction()
    },
    exportGeoJSON() {
      var features = this.tempSource_.getFeatures()
      FeaturesWriter.exportGeoJSON(features)
    },
    Close() {
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style scoped>
/*
  临时图层绘制组件样式
  @component SdTemporaryEditor
*/
.sd-temporary-editor {
  position: absolute;
  top: 10px;
  right: 60px;
  z-index: 50;
}
.sd-temporary-editor .editor-button-panel {
  padding: 5px;
}
</style>